// extracted by mini-css-extract-plugin
export default {"tooltip":"Pm-z","sharingV2":"Qm-z","sharingIconsV2":"Rm-z","links":"Sm-z","link":"Tm-z","facebookV2":"Um-z","twitterV2":"Vm-z","pinterestV2":"Wm-z"};